<template>
    <b-row>
        <b-col>
            <datetime v-model="fullTimeString"
                      type="time"
                      input-class="form-control"
                      :state="state"
                      value-zone="local"
                      v-if="isIE">
                <b-button slot="after"
                          :disabled="!fullTimeString"
                          @click="time = null">X
                </b-button>
            </datetime>
            <b-form-input :state="state"
                          v-model="time"
                          type="time"
                          :disabled="disabled"
                          v-if="!isIE"></b-form-input>
        </b-col>
    </b-row>
</template>

<script>
    import {DateTime} from "luxon";

    export default {
        name: 'TimeInput',
        props: {
            value: [Date, String],
            disabled: Boolean,
            state: {
                type: Boolean,
                default: null,
            }
        },
        data() {
            return {
                fullTimeString: null,
                time: null,
            }
        },
        mounted() {
            if (this.value) {
                if (this.value instanceof Date) {
                    let d = DateTime.fromJSDate(this.value);
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.time = d.toFormat('HH:mm');
                } else {
                    let d = DateTime.fromISO(this.value);
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.time = d.toFormat('HH:mm');
                }
            }
        },
        computed: {
            isIE() {
                let userAgent = window.navigator.userAgent;
                var msie = userAgent.indexOf("MSIE ");

                if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
                {
                    return true;
                } else {
                    return false;
                }
            },
        },
        watch: {
            value(newVal) {
                if (newVal instanceof Date) {
                    let d = DateTime.fromJSDate(newVal);
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.time = d.toFormat('HH:mm');
                } else {
                    let d = DateTime.fromISO(newVal);
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.time = d.toFormat('HH:mm');
                }
            },
            fullTimeString(newVal) {
                if (newVal && newVal.length !== 10) {
                    this.time = DateTime.fromISO(newVal).toFormat('HH:mm');
                } else {
                    this.emitIfValid();
                }
            },
            time() {
                this.emitIfValid();
            },
        },
        methods: {
            emitIfValid() {
                this.$emit('input', this.time);

                // let date = DateTime.fromISO(this.date + 'T' + this.time);
                // if (!date.invalid) {
                //     this.$emit('input', date.toISO());
                // } else {
                //     this.$emit('input', null);
                // }
            },
        },
    }
</script>